export default function About() {
  const values = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Innovation',
      description: 'Pushing boundaries with cutting-edge solutions'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Precision',
      description: 'Every detail matters in our work'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration',
      description: 'Your vision + our expertise = magic'
    },
    {
      icon: 'ri-fire-line',
      title: 'Passion',
      description: 'We love what we do, and it shows'
    }
  ];

  return (
    <section className="py-24 px-6 bg-[#EBEBE0]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-[#182114] mb-6" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
            Who We <span className="text-[#D96B33]">Are</span>
          </h2>
          <div className="w-24 h-1 bg-[#D96B33] mx-auto mb-8"></div>
          <p className="text-xl text-[#2E3F25] max-w-4xl mx-auto leading-relaxed" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
            A creative and technical team blending design, software, AI, and quality assurance to deliver high-performance web experiences. We're not your typical agency — we're builders, dreamers, and problem-solvers who turn complex challenges into elegant solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {values.map((value, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-[#D96B33] cursor-pointer"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#D96B33] to-[#AFC4E4] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#182114] mb-3" style={{ fontFamily: '"Distro Bold", sans-serif' }}>
                {value.title}
              </h3>
              <p className="text-[#2E3F25]" style={{ fontFamily: '"Century Gothic", sans-serif' }}>
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
